/**
 * The per-screen price of a sales-managed (sync-priced / Enterprise) contract, in major units.
 *
 * Such an account is billed on a price sales set directly in Stripe, which is NOT the catalog price
 * of its plan feature — the Billing page's plan row already shows it from `getSubscriptionInfoStripe`
 * (`plan.amount`, cents). The change dialog priced its "Screens added, 1 × … each" line from the
 * catalog instead, so a $7.00 contract read "1 × $10.00/mo each" beside a correct $6.83 charge
 * (scio3#2754). This reads the same source the plan row reads.
 *
 * `undefined` when there is no usable amount (no subscription yet, a tiered price whose `amount` is
 * null, a zero price) — the caller then falls back to the catalog price, as before.
 */
export function readContractPricePerScreen(subscriptionInfo: unknown): number | undefined {
  if (!subscriptionInfo || typeof subscriptionInfo !== 'object') return undefined;
  const plan = (subscriptionInfo as { plan?: unknown }).plan;
  if (!plan || typeof plan !== 'object') return undefined;
  const amount = (plan as { amount?: unknown }).amount;
  if (typeof amount !== 'number' || !Number.isFinite(amount) || amount <= 0) return undefined;
  return amount / 100;
}
